module.exports = __webpack_public_path__ + "static/media/trello.a37dc394.svg";